/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, h } from './index-ef0fa435.js';

const pushButtonCss = "slot-fb[hidden].sc-lar-push-button-content,slot[hidden].sc-lar-push-button-content{display:initial !important}.content.sc-lar-push-button-content{padding-top:2rem}";

const PushButtonContent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.color = undefined;
    this.disabled = undefined;
  }
  // @Event() click!: EventEmitter; // populates
  render() {
    return (h("div", { class: "content" }, h("lar-button-push", { color: this.color, disabled: this.disabled })));
  }
};
PushButtonContent.style = pushButtonCss;

export { PushButtonContent as lar_push_button_content };

//# sourceMappingURL=lar-push-button-content.entry.js.map